module.exports = __webpack_public_path__ + "media/images/icons/menu_profile-9460d8a27656e43c3d0f9326be1037ba.svg";